var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('h1',[_vm._v("Deposit")]),_c('form-edit-deposit-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }